var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M0.999999 0.999999L5.23178 6.07813C5.63157 6.55789 6.36843 6.55789 6.76822 6.07813L11 1",
    stroke: "rgba(179, 199, 217, 1)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.8a076f551bc7dc11a0dab2f44e16c492.svg";
export { ForwardRef as ReactComponent };